(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rare-newsletter-popup"] && !Shopify.designMode) return;
  try {
    
  const initializeRareNewsletterPopup = (root) => {
    if (!root || root.dataset.initialized === 'true') return;

    const dialog = root.querySelector('.rare-newsletter-popup__dialog');
    const status = root.querySelector('[data-popup-status]')?.dataset.popupStatus || 'idle';
    const formState = root.querySelector('[data-rare-newsletter-form-state]');
    const successState = root.querySelector('[data-rare-newsletter-success-state]');
    const delay = Number(root.dataset.delayMs) || 0;
    const designMode = root.dataset.designMode === 'true';
    const storageKey = 'rare-newsletter-popup-shown-v3';
    let timer;

    if (!dialog) return;

    root.dataset.initialized = 'true';

    const hasShown = () => {
      try {
        return localStorage.getItem(storageKey) === 'true';
      } catch {
        return false;
      }
    };

    const rememberShown = () => {
      if (designMode) return;

      try {
        localStorage.setItem(storageKey, 'true');
      } catch {
        return;
      }
    };

    const openPopup = (remember = false) => {
      if (!dialog.open) {
        dialog.showModal();
        document.documentElement.style.overflow = 'hidden';
        if (remember) rememberShown();
      }
    };

    const closePopup = () => {
      rememberShown();
      if (dialog.open) dialog.close();
    };

    const showSuccessState = () => {
      if (formState) formState.hidden = true;
      if (successState) {
        successState.hidden = false;
        dialog.setAttribute('aria-labelledby', successState.dataset.titleId || '');
        dialog.setAttribute('aria-describedby', successState.dataset.subtitleId || '');
      }
    };

    const openSuccessPopup = () => {
      window.clearTimeout(timer);
      showSuccessState();
      openPopup();
      rememberShown();
    };

    const schedulePopup = () => {
      if (designMode || status === 'error' || status === 'success') {
        if (status === 'success') showSuccessState();
        openPopup();
        if (status === 'success') rememberShown();
        return;
      }

      if (hasShown()) return;
      timer = window.setTimeout(() => openPopup(true), delay);
    };

    root.querySelectorAll('[data-rare-newsletter-close]').forEach((button) => {
      button.addEventListener('click', closePopup);
    });

    root.querySelectorAll('[data-rare-newsletter-copy-code]').forEach((button) => {
      button.addEventListener('click', async () => {
        const code = button.dataset.code || '';
        const label = button.querySelector('[data-rare-newsletter-copy-label]');

        if (!code) return;

        try {
          await navigator.clipboard.writeText(code);
          if (label) label.textContent = 'Copied';
        } catch {
          const selection = window.getSelection();
          const range = document.createRange();
          const codeText = button.querySelector('strong');

          if (!selection || !codeText) return;
          range.selectNodeContents(codeText);
          selection.removeAllRanges();
          selection.addRange(range);
        }
      });
    });

    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) closePopup();
    });

    dialog.addEventListener('cancel', (event) => {
      event.preventDefault();
      closePopup();
    });

    dialog.addEventListener('close', () => {
      document.documentElement.style.overflow = '';
    });

    const handleSignupSuccess = () => openSuccessPopup();

    root.addEventListener('shopify:block:select', openPopup);
    document.addEventListener('rare-newsletter:success', handleSignupSuccess);

    if (document.querySelector('[data-rare-footer-newsletter-success]')) {
      openSuccessPopup();
    } else {
      schedulePopup();
    }

    root.addEventListener('rare-newsletter-popup:destroy', () => {
      window.clearTimeout(timer);
      document.removeEventListener('rare-newsletter:success', handleSignupSuccess);
      if (dialog.open) dialog.close();
    }, { once: true });
  };

  document.querySelectorAll('[data-rare-newsletter-popup]').forEach(initializeRareNewsletterPopup);

  document.addEventListener('shopify:section:load', (event) => {
    initializeRareNewsletterPopup(event.target.querySelector('[data-rare-newsletter-popup]'));
  });

  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelector('[data-rare-newsletter-popup]')?.dispatchEvent(new CustomEvent('rare-newsletter-popup:destroy'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rare-product-layout"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rare-product-gallery')) {
    customElements.define('rare-product-gallery', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const track = this.querySelector('.rare-product-media');
        const slides = [...track.children];
        const previous = this.querySelector('[data-gallery-previous]');
        const next = this.querySelector('[data-gallery-next]');
        const counter = this.querySelector('[data-gallery-index]');
        if (!previous || !next) return;
        this.querySelector('.rare-gallery-controls').hidden = false;
        const index = () => {
          const left = track.getBoundingClientRect().left;
          return slides.reduce((best, slide, i) => Math.abs(slide.getBoundingClientRect().left - left) < Math.abs(slides[best].getBoundingClientRect().left - left) ? i : best, 0);
        };
        const update = () => {
          counter.textContent = index() + 1;
          previous.disabled = track.scrollLeft <= 1;
          next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 1;
        };
        const move = direction => {
          const target = slides[Math.max(0, Math.min(slides.length - 1, index() + direction))];
          const left = track.scrollLeft + target.getBoundingClientRect().left - track.getBoundingClientRect().left;
          track.scrollTo({ left, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        };
        previous.addEventListener('click', () => move(-1), options);
        next.addEventListener('click', () => move(1), options);
        track.addEventListener('scroll', update, { ...options, passive: true });
        track.addEventListener('keydown', event => {
          if (event.target !== track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          move(event.key === 'ArrowRight' ? 1 : -1);
        }, options);
        window.addEventListener('resize', update, options);
        update();
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rare-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rare-reviews')) {
    customElements.define('rare-reviews', class extends HTMLElement {
      connectedCallback() {
        if (this.started) return;
        this.started = true;
        this.page = 0;
        this.pending = false;
        this.widget = this.querySelector('[data-rare-oke-widget]');
        this.status = this.querySelector('[data-review-status]');
        this.retry = this.querySelector('[data-review-retry]');
        this.pagination = this.querySelector('[data-review-pagination]');
        this.previous = this.querySelector('[data-review-prev]');
        this.next = this.querySelector('[data-review-next]');
        this.dialog = this.querySelector('dialog');
        this.querySelector('[data-review-open]').addEventListener('click', () => this.dialog.showModal());
        this.querySelector('[data-review-close]').addEventListener('click', () => this.dialog.close());
        this.dialog.addEventListener('click', event => { if (event.target === this.dialog) { const bounds = this.dialog.getBoundingClientRect(); if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close(); } });
        this.previous.addEventListener('click', () => { this.page = Math.max(0, this.page - 1); this.update(); });
        this.next.addEventListener('click', () => this.advance());
        this.retry.addEventListener('click', () => this.start());
        this.widget.addEventListener('change', () => { this.page = 0; });
        this.mobile = matchMedia('(max-width: 599px)');
        this.resize = () => { this.page = 0; this.update(); };
        this.mobile.addEventListener('change', this.resize);
        this.observer = new MutationObserver(() => this.update());
        this.observer.observe(this.widget, { childList: true, subtree: true });
        this.start();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.mobile?.removeEventListener('change', this.resize);
        clearTimeout(this.timeout);
        clearTimeout(this.moreTimeout);
      }
      async loadSDK() {
        if (window.okeWidgetApi) return window.okeWidgetApi;
        if (!window.rareOkendoLoader) {
          window.rareOkendoLoader = new Promise((resolve, reject) => {
            let script = document.querySelector('script[src*="/reviews-widget-plus/js/okendo-reviews.js"]');
            const loaded = () => { if (window.okeWidgetApi) { clearTimeout(timer); document.removeEventListener('oke-script-loaded', loaded); resolve(window.okeWidgetApi); } };
            const timer = setTimeout(() => { document.removeEventListener('oke-script-loaded', loaded); reject(new Error('Okendo load timeout')); }, 18000);
            document.addEventListener('oke-script-loaded', loaded);
            if (!script) {
              script = document.createElement('script');
              script.src = 'https://cdn-static.okendo.io/reviews-widget-plus/js/okendo-reviews.js';
              script.async = true;
              script.setAttribute('data-oke-subscriber-id', this.dataset.subscriber);
              script.addEventListener('error', () => { clearTimeout(timer); document.removeEventListener('oke-script-loaded', loaded); script.remove(); reject(new Error('Okendo unavailable')); }, { once: true });
              document.head.append(script);
            }
            loaded();
          }).catch(error => { window.rareOkendoLoader = null; throw error; });
        }
        return window.rareOkendoLoader;
      }
      async start() {
        this.status.hidden = false;
        this.status.textContent = this.dataset.loading;
        this.retry.hidden = true;
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => this.fail(), 25000);
        try {
          const api = await this.loadSDK();
          if (!this.isConnected) return;
          await api.setWidgetSettings({ reviewsWidget: { reviews: { list: { initialPageSize: 3, loadMorePageSize: 3, layout: { name: 'default' } } } } });
          this.widget.setAttribute('data-oke-widget', '');
          await api.initWidget(this.widget, true);
          this.update();
        } catch { this.fail(); }
      }
      fail() {
        clearTimeout(this.timeout);
        this.status.hidden = false;
        this.status.textContent = this.dataset.loadError;
        this.retry.hidden = false;
      }
      rows() { return [...this.widget.querySelectorAll('.oke-w-reviews-list-item')]; }
      size() { return this.mobile.matches ? 1 : 3; }
      moreButton() { return this.widget.querySelector('.oke-showMore-button'); }
      update() {
        const rows = this.rows();
        if (!rows.length) {
          this.pagination.hidden = true;
          if (this.widget.querySelector('.oke-w')?.textContent.trim()) { clearTimeout(this.timeout); this.status.hidden = true; this.retry.hidden = true; }
          return;
        }
        clearTimeout(this.timeout);
        this.status.hidden = true;
        this.retry.hidden = true;
        if (this.pending && rows.length > this.beforeLoad) {
          this.pending = false;
          clearTimeout(this.moreTimeout);
          this.page += 1;
        }
        const size = this.size();
        this.page = Math.min(this.page, Math.ceil(rows.length / size) - 1);
        const start = this.page * size;
        rows.forEach((row, index) => { row.hidden = index < start || index >= start + size; });
        this.pagination.hidden = false;
        this.setAttribute('data-pagination-ready', '');
        this.previous.disabled = this.pending || this.page === 0;
        this.next.disabled = this.pending || (start + size >= rows.length && !this.moreButton());
        this.querySelector('[data-review-position]').textContent = `${start + 1}-${Math.min(start + size, rows.length)}`;
      }
      advance() {
        if (this.pending) return;
        const rows = this.rows();
        if ((this.page + 1) * this.size() < rows.length) { this.page += 1; this.update(); return; }
        const more = this.moreButton();
        if (!more) return;
        this.pending = true;
        this.beforeLoad = rows.length;
        this.update();
        more.click();
        this.moreTimeout = setTimeout(() => { this.pending = false; this.update(); this.status.hidden = false; this.status.textContent = this.dataset.loadError; }, 18000);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
